// extracted by mini-css-extract-plugin
export var boxItems = "_27-1";
export var boxItemsLg = "_27-2";
export var button = "_27-7";
export var buttonHoverless = "_27-9";
export var buttonLg = "_27-8";
export var filterGroupBox = "_27-0";
export var icon = "_27-3";
export var iconSecondary = "_27-6";
export var iconWrapper = "_27-4";
export var iconWrapperLg = "_27-5";
export var truncatedLabel = "_27-a";